import { Card } from "primereact/card";

const PartnerWalletSummaryCards = ({
  transactions = [],
  searchedAccountId = null,
}) => {

  const summary = transactions.reduce(
    (acc, tx) => {
      const debit = tx.debit ? parseFloat(tx.debit) : 0;
      const credit = tx.credit ? parseFloat(tx.credit) : 0;

      acc.totalDebit += debit;
      acc.totalCredit += credit;
      acc.count += 1;

      return acc;
    },
    { totalDebit: 0, totalCredit: 0, count: 0 },
  );

  // Get the current balance from the first transaction
  // The balance should already be correctly set in transformWalletTransactions
  const currentBalance =
    transactions.length > 0 ? parseFloat(transactions[0].balance) || 0 : 0;

  return (
    <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-6">
      <Card>
        <div className="p-4">
          <p className="text-sm text-gray-600 mb-2">Total Credit (In)</p>
          <p className="text-2xl font-bold text-green-600">
            +₱ {summary.totalCredit.toFixed(2)}
          </p>
        </div>
      </Card>

      <Card>
        <div className="p-4">
          <p className="text-sm text-gray-600 mb-2">Total Debit (Out)</p>
          <p className="text-2xl font-bold text-red-600">
            -₱ {summary.totalDebit.toFixed(2)}
          </p>
        </div>
      </Card>

      <Card>
        <div className="p-4">
          <p className="text-sm text-gray-600 mb-2">Net Balance</p>
          <p
            className={`text-2xl font-bold ${
              currentBalance >= 0 ? "text-green-600" : "text-red-600"
            }`}
          >
            ₱ {currentBalance.toFixed(2)}
          </p>
        </div>
      </Card>

      <Card>
        <div className="p-4">
          <p className="text-sm text-gray-600 mb-2">Total Transactions</p>
          <p className="text-2xl font-bold text-gray-900">{summary.count}</p>
        </div>
      </Card>
    </div>
  );
};

export default PartnerWalletSummaryCards;
